module.exports = __webpack_public_path__ + "static/media/deck-grid-2.f3e62544.webp";